// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".two-dimensional-image .canvas__img{visibility:hidden}.two-dimensional-image .canvas .konva-wrapper{background:transparent;position:absolute;top:0}\n", ""]);
// Exports
module.exports = exports;
